module.exports = __webpack_public_path__ + "img/logo.2d4ef4b4.svg";